import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { CtxAuth } from "views/utils/Contexts";

export function Header(): JSX.Element{

    const hisotry = useHistory();
    const cua = useContext(CtxAuth);

    // ログアウト処理
    function clickLogout(){
        cua.logout(function(){hisotry.push('/admin/login')});
    }

    return (
        <header className="admin-header">
            <div className="control-horizon control-vcenter">
                <h1 className="site-title">mitsumol</h1>
                <span>SEISHO</span>
                <a href={process.env.REACT_APP_HOMEPAGEURL} target="_blank" className="btn-pc-header btn-icon-left"><span className="icon material-icons-round md-18">home</span>サイトを表示する</a>
            </div>
            <a onClick={clickLogout} className="btn-pc-header btn-icon-left logout-link" target="_top"><span className="icon material-icons-round md-18">logout</span>ログアウト</a>
            <div className="btn-sp-header-right">
                <button onClick={function(){window.open(process.env.REACT_APP_HOMEPAGEURL + "", '_blank')}} className="btn-sp-header btn-sp-home"><span className="material-icons-round">home</span></button>
                <button onClick={clickLogout} className="btn-sp-header btn-sp-logout"><span className="material-icons-round">logout</span></button>
            </div>
        </header>
    )
}